import {register} from './../exports/theme-sections';
import popoutSection from './../features/popout';

const footerSection = {
  onLoad() {
    // Lighthouse fires security warning for the Shopify link.
    var shopifyLink = document.querySelector('[data-powered-link] a');
    if (shopifyLink) {
      shopifyLink.setAttribute('rel', 'noopener');
    }
  },
};

register('footer', [popoutSection, footerSection]);
